import styled from 'styled-components/macro';
import { linkStyling } from 'styles/base-classes';

export const StyledLink = styled('a')`
  ${linkStyling};
  &.button.link {
    padding-bottom: 10px;
  }
`;

export const UserDataWrapper = styled('div')`
  padding: 12px 16px;
  border-top: 1px solid #e8ebed;
  border-bottom: 1px solid #e8ebed;
`;

export const BlockWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const EditButton = styled('div')`
  font-size: 13px;
  font-weight: 600;
  color: #0bd6a7;
  margin-right: 16px;
  cursor: pointer;
`;

export const TopWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ItemWrapper = styled(TopWrapper)<any>`
  margin-top: 16px;

  button {
    height: 44px;
    width: 285px;
    text-align: left;
  }

  ul {
    min-width: 285px;
    max-height: ${({ maxHeight }): string => (maxHeight ? maxHeight : '20em')};
  }
`;

export const Title = styled('h2')`
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  text-align: left;
  margin-bottom: -8px;
  color: #001247;

  white-space: normal;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const SubTitle = styled('span')`
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  color: #8ea6be;
`;

export const ModalWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 64px 80px 54px 64px;
  padding: 48px 60px 40px 48px;
  max-width: 1150px;
  justify-content: space-between;
  position: relative;
  min-width: 700px;

  @media screen and (min-width: 850px) {
    min-width: 720px;
  }
  @media screen and (min-width: 950px) {
    min-width: 820px;
  }
  @media screen and (min-width: 1100px) {
    min-width: 970px;
  }
`;

export const RemoveButtonWrapper = styled('div')`
  position: absolute;
  top: 20px;
  right: 10px;
  transform: scale(2);

  svg {
    cursor: pointer;
  }
`;

export const ModalTitle = styled('h1')`
  font-size: 30px;
  font-weight: 700;
  color: #001247;
  margin-bottom: 20px;
`;

export const ModalSubTitle = styled('div')`
  color: #000000;
  font-size: 18px;
  font-weight: 500;
  line-height: 51px;

  border-bottom: 1px solid #d6d6d6;
  text-decoration: underline 5px solid #0bd6a7;
  text-underline-offset: 13px;
`;

export const ModalText = styled('p')`
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  margin: 30px 0 0 0;
`;

export const ItemTitle = styled('h1')`
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  line-height: 29px;
  margin: 0;
`;

export const ItemSubTitle = styled('h2')`
  color: #000000;
  font-size: 13px;
  font-weight: 400;
  line-height: 29px;
  margin: 0;
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-self: end;
  margin-top: 50px;

  button {
    width: 140px;
  }
`;
